import styled from 'styled-components';
import { COLORS, SIZING } from '../../../styles/variables';

export const CTAsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: ${SIZING.unit(3)};
`;

export const Button = styled.button<{ variant?: string }>`
  cursor: pointer;
  background-color: transparent;
  border: 1px solid ${COLORS.black};
  /* box-shadow: inset 0 0 0 1px ${COLORS.black}; */
  width: 100%;
  padding: 16px 32px;
  font-family: 'Audi Type';
  color: ${({ variant }) => (variant === 'primary' ? COLORS.white : COLORS.black)};
  background-color: ${({ variant }) => (variant === 'primary' ? COLORS.black : COLORS.white)};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.002px;
`;
